/**
 * Converts text with html entities into plain text
 *
 * @param  {String} value of text with html entities
 * @return {String} value of text with html entities decoded into text
 */
import he from 'he';

export default function entityToText(text) {
  return he.unescape(text);
}
